import { createApp } from 'vue';

/**
 * The single application instance (Vue 3).
 *
 * Vue 2 exposed a global `Vue` constructor whose `.prototype`, `.component()`,
 * `.use()` and `.directive()` mutated every instance. Vue 3 scopes all of that
 * to an application instance, so helper/bootstrap modules import this singleton
 * and register globals through `app.config.globalProperties`, `app.component`,
 * `app.use` and `app.directive`.
 *
 * The root component is intentionally template-less: the app mounts onto the
 * server-rendered `<div id="app">…</div>` markup and Vue uses that element's
 * inner HTML as the template (full build with runtime compiler — see
 * webpack.mix.js `vue({ runtimeOnly: false })`).
 */
const app = createApp({
    name: 'HrmsRoot',
});

// Convenience handle for modules that previously assigned to `Vue.prototype`.
export const globals = app.config.globalProperties;

export default app;
